import moment from 'moment';
//import Swal from 'sweetalert2'
/*import AddMunicipality from './AddMunicipality/AddMunicipality.vue';*/
export default {
    name: 'Profile',
    components: {
        /*'add-municipality': AddMunicipality*/
    },
    created() {   
        window.scrollTo(0, 0);
       
       
    },
    filters: {
        moment: function (date) {
            if (date === null) {
                return "فارغ";
            }
            // return moment(date).format('MMMM Do YYYY, h:mm:ss a');
            return moment(date).format('MMMM Do YYYY');
        }
    },
    data() {
        return {
            state: 1,
            userType:null,
            form: {

                CurrentPassword: '',
                Password: null,
                CPassword:''
            }
        };
    },
    methods: {

        ChangePassword() {
          

            if (!this.form.CurrentPassword) {
                this.$message({
                    message: 'الرجاء إدخال كلمة المرور الحالية',
                    type: 'error'
                });

                return;
            }

            if (!this.form.Password)
            {
                this.$message({
                    message: 'الرجاء إدخال كلمة المرور',
                    type: 'error'
                });

                return;
            }

            if (this.form.Password.length < 8) {
                this.$message({
                    message: 'كلمة المرور يجب أن تتكون من 8 أحرف على الأقل',
                    type: 'error'
                });
                return;
            }

            if (this.form.Password != this.form.CPassword) {
                this.$message({
                    message: 'كلمة المرور غير متطابقة',
                    type: 'error'
                });
                return;
            }
            this.$blockUI.Start();
            this.$http.ChangePasswords(this.form).then(response => {

               this.$blockUI.Stop();
                this.$message({
                    message: response.data,
                    type: 'success'
                });
                window.location.href = "/";

            }).catch(error => {
                this.$blockUI.Stop();
                this.$message({
                    message: error.response.data,
                    type: 'error'
                });
            })
        }
   
    }    
}
